export default __webpack_public_path__ + "static/media/ic_email.5aa72efd.svg";